/**
 * Created by Frank on 2017/9/6.
 */
const GAODE_MAP_KEY = '338c4f90697db09e65af7c7b36c06c61'
const JSON_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss ZZ'
const HTML_INPUT_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const HTML_INPUT_DATE_FORMAT = 'YYYY-MM-DD'
const HTML_INPUT_TIMEONLY_FORMAT = 'HH:mm:ss'

const CHARGER_STATUS_METRIC_HASH = {
  0: 'offline',
  1: 'available',
  2: 'ready',
  3: 'charged',
  4: 'charging',
  // 5: 'trickling',
  6: 'maintaining',
  7: 'fault'
}

export { GAODE_MAP_KEY, JSON_TIME_FORMAT, HTML_INPUT_TIME_FORMAT, HTML_INPUT_DATE_FORMAT, HTML_INPUT_TIMEONLY_FORMAT, CHARGER_STATUS_METRIC_HASH }
